import { createContext, useContext } from 'react'
import CommonStore from "./CommonStore";
import UserStore from "./UserStore";
import CustomerStore from "./CustomerStore"

interface Store {
    commonStore: CommonStore;
    userStore: UserStore;
    customerStore: CustomerStore;
}

export const store: Store = {
    commonStore: new CommonStore(),
    userStore: new UserStore(),
    customerStore: new CustomerStore(),
}

export const StoreContext = createContext(store);

export function useStore() {

    return useContext(StoreContext);
}